module.exports = __webpack_public_path__ + "static/media/e19.8e3141e6.jpg";